export const plusMinus = {
  name: "plus-minus" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M.1 12A6.9 6.9 0 0 1 7 5.1h10a6.9 6.9 0 0 1 0 13.8H7A6.9 6.9 0 0 1 .1 12ZM7 6.9a5.1 5.1 0 1 0 0 10.2h10a5.1 5.1 0 0 0 0-10.2H7Zm9.5 2.2a.9.9 0 0 1 .9.9v1.1h1.1a.9.9 0 0 1 0 1.8h-1.1V14a.9.9 0 0 1-1.8 0v-1.1h-1.1a.9.9 0 1 1 0-1.8h1.1V10a.9.9 0 0 1 .9-.9ZM4.6 12a.9.9 0 0 1 .9-.9h4a.9.9 0 1 1 0 1.8h-4a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["plus-minus"],
  category: "other" as const,
};
